
	import {
		Vue,
		Component,
		Emit,
		Prop
	} from "vue-property-decorator";

	@Component({
		components: {},
	})
	//export default class "组件名" extends Vue
	
	@Component
	export default class empty extends Vue {
		height:String = "calc(70vh)";
		mounted() {

		};

		created() {
			// this.courseList.length = 5;
		};
	}
